import { Space } from '@drip/drip-design';
import { useEffect, useState } from 'react';
import { getQuery } from '@/common/utils';
import { connect } from 'react-redux';
import { setNewFeedbackInstance } from '@/store/new-feedback-instance';
import env from '@/env';
import ComponentLog from '@/components/component-log';
import { useConfig } from '@/apis/ducc';

// 动态加载反馈组件
async function loadScripts(src) {
  if (window.AcoreFeedback && window.AcoreFeedback.renderFeedBack) {
    return Promise.resolve(window.AcoreFeedback.renderFeedback);
  }
  let resolve, reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  const scriptDom = document.createElement('script');
  scriptDom.type = 'text/javascript';
  scriptDom.addEventListener('load', (ev) => resolve(window.AcoreFeedback.renderFeedBack));
  // scriptDom.addEventListener('load', (ev) => resolve(undefined))
  scriptDom.addEventListener('error', (ev) => reject(ev));
  scriptDom.src = src;
  scriptDom.defer = true;
  document.body.appendChild(scriptDom);

  return promise;
}

const FeedBack = (props) => {
  const [feedBack, setFeedBack] = useState();
  const [getConfig] = useConfig();
  const topin = getConfig('GLOGAL_CONSULTATION', '1025945791'); // 咚咚群咨询

  useEffect(() => {
    const isfromBabel = getQuery('origin') === 'Babel';
    if (isfromBabel) return;

    loadScripts(env.GLOBAL_FEEDBACK_JS).then((fed) => {
      setFeedBack(() => fed);
    });
  }, []);

  useEffect(() => {
    if (feedBack == null) return;
    let fb = feedBack({
      container: document.getElementById('acore-feedback'),
      snapContainer: document.getElementById('root'),
      sourceType: 1,
      showWithoutIcon: true,
    });
    fb.mount().then((instan) => {
      props.setNewFeedbackInstance(instan);
    });

    return () => {
      try {
        fb.unMount();
      } catch (ex) {
        console.error(ex);
      }
    };

    // eslint-disable-next-line
  }, [feedBack]);

  return (
    <Space className="nav-feed-back" size={24}>
      <div className="help icon-item" onClick={() => window.open('/help/')}>
        <span className="normal-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M17.9163 9.99992C17.9163 15.2777 15.2775 17.9166 9.99967 17.9166C4.7219 17.9166 2.08301 15.2777 2.08301 9.99992C2.08301 4.72214 4.7219 2.08325 9.99967 2.08325C15.2775 2.08325 17.9163 4.72214 17.9163 9.99992Z"
              stroke="#595959"
              stroke-width="1.4"
            />
            <path
              d="M7.21699 8.28125C7.21699 8.66785 7.53039 8.98125 7.91699 8.98125C8.30359 8.98125 8.61699 8.66785 8.61699 8.28125H7.21699ZM9.30033 11.25C9.30033 11.6366 9.61373 11.95 10.0003 11.95C10.3869 11.95 10.7003 11.6366 10.7003 11.25H9.30033ZM10.9619 10.0837L11.279 10.7077L10.9619 10.0837ZM8.61699 8.28125C8.61699 7.56262 9.21952 6.95 10.0003 6.95V5.55C8.47995 5.55 7.21699 6.75622 7.21699 8.28125H8.61699ZM10.0003 6.95C10.7811 6.95 11.3837 7.56262 11.3837 8.28125H12.7837C12.7837 6.75622 11.5207 5.55 10.0003 5.55V6.95ZM10.3475 10.5357C9.84565 10.0478 9.84553 10.0479 9.84541 10.048C9.84537 10.0481 9.84524 10.0482 9.84516 10.0483C9.84499 10.0484 9.84481 10.0486 9.84463 10.0488C9.84427 10.0492 9.84388 10.0496 9.84348 10.05C9.84266 10.0509 9.84176 10.0518 9.84077 10.0528C9.83879 10.0549 9.83647 10.0573 9.83383 10.0601C9.82854 10.0658 9.82195 10.0729 9.81424 10.0814C9.79885 10.0983 9.77876 10.1211 9.75554 10.149C9.70969 10.204 9.64858 10.2825 9.58653 10.3782C9.47652 10.5479 9.30033 10.8667 9.30033 11.25H10.7003C10.7003 11.2762 10.6977 11.2378 10.7613 11.1397C10.7861 11.1015 10.8118 11.0683 10.831 11.0452C10.8404 11.034 10.8474 11.0261 10.851 11.0222C10.8528 11.0202 10.8537 11.0193 10.8535 11.0195C10.8534 11.0196 10.853 11.02 10.8523 11.0207C10.852 11.021 10.8516 11.0214 10.8511 11.0219C10.8509 11.0222 10.8506 11.0225 10.8503 11.0227C10.8502 11.0229 10.8501 11.023 10.8499 11.0232C10.8498 11.0233 10.8497 11.0234 10.8497 11.0234C10.8496 11.0235 10.8494 11.0237 10.3475 10.5357ZM11.3837 8.28125C11.3837 8.78454 11.0919 9.23241 10.6447 9.45964L11.279 10.7077C12.1651 10.2574 12.7837 9.34529 12.7837 8.28125H11.3837ZM10.6447 9.45964C10.2788 9.6456 10.0649 9.82228 9.84565 10.0478L10.8494 11.0237C10.9775 10.892 11.0696 10.8141 11.279 10.7077L10.6447 9.45964Z"
              fill="#595959"
            />
            <circle cx="9.99967" cy="13.5417" r="1.04167" fill="#595959" />
          </svg>
        </span>
        <span className="active-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M17.9163 9.99992C17.9163 15.2777 15.2775 17.9166 9.99967 17.9166C4.7219 17.9166 2.08301 15.2777 2.08301 9.99992C2.08301 4.72214 4.7219 2.08325 9.99967 2.08325C15.2775 2.08325 17.9163 4.72214 17.9163 9.99992Z"
              stroke="#007AFF"
              stroke-width="1.4"
            />
            <path
              d="M7.21699 8.28125C7.21699 8.66785 7.53039 8.98125 7.91699 8.98125C8.30359 8.98125 8.61699 8.66785 8.61699 8.28125H7.21699ZM9.30033 11.25C9.30033 11.6366 9.61373 11.95 10.0003 11.95C10.3869 11.95 10.7003 11.6366 10.7003 11.25H9.30033ZM10.9619 10.0837L11.279 10.7077L10.9619 10.0837ZM8.61699 8.28125C8.61699 7.56262 9.21952 6.95 10.0003 6.95V5.55C8.47995 5.55 7.21699 6.75622 7.21699 8.28125H8.61699ZM10.0003 6.95C10.7811 6.95 11.3837 7.56262 11.3837 8.28125H12.7837C12.7837 6.75622 11.5207 5.55 10.0003 5.55V6.95ZM10.3475 10.5357C9.84565 10.0478 9.84553 10.0479 9.84541 10.048C9.84537 10.0481 9.84524 10.0482 9.84516 10.0483C9.84499 10.0484 9.84481 10.0486 9.84463 10.0488C9.84427 10.0492 9.84388 10.0496 9.84348 10.05C9.84266 10.0509 9.84176 10.0518 9.84077 10.0528C9.83879 10.0549 9.83647 10.0573 9.83383 10.0601C9.82854 10.0658 9.82195 10.0729 9.81424 10.0814C9.79885 10.0983 9.77876 10.1211 9.75554 10.149C9.70969 10.204 9.64858 10.2825 9.58653 10.3782C9.47652 10.5479 9.30033 10.8667 9.30033 11.25H10.7003C10.7003 11.2762 10.6977 11.2378 10.7613 11.1397C10.7861 11.1015 10.8118 11.0683 10.831 11.0452C10.8404 11.034 10.8474 11.0261 10.851 11.0222C10.8528 11.0202 10.8537 11.0193 10.8535 11.0195C10.8534 11.0196 10.853 11.02 10.8523 11.0207C10.852 11.021 10.8516 11.0214 10.8511 11.0219C10.8509 11.0222 10.8506 11.0225 10.8503 11.0227C10.8502 11.0229 10.8501 11.023 10.8499 11.0232C10.8498 11.0233 10.8497 11.0234 10.8497 11.0234C10.8496 11.0235 10.8494 11.0237 10.3475 10.5357ZM11.3837 8.28125C11.3837 8.78454 11.0919 9.23241 10.6447 9.45964L11.279 10.7077C12.1651 10.2574 12.7837 9.34529 12.7837 8.28125H11.3837ZM10.6447 9.45964C10.2788 9.6456 10.0649 9.82228 9.84565 10.0478L10.8494 11.0237C10.9775 10.892 11.0696 10.8141 11.279 10.7077L10.6447 9.45964Z"
              fill="#007AFF"
            />
            <circle cx="9.99967" cy="13.5417" r="1.04167" fill="#007AFF" />
          </svg>
        </span>
        <span className="icon-title">帮助</span>
      </div>

      <ComponentLog>
        <div
          clstag="yx_center|top navigation_customer service"
          className="custom-service icon-item"
          onClick={() => {
            window.location.href = `timline://chat/?topin=${topin}&type=2`;
          }}
        >
          <span className="normal-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M15.4224 4.34155C17.9844 6.9036 18.3992 10.805 16.6753 13.829C15.9227 15.2005 18.0157 16.2733 17.0705 17.2186C16.1253 18.1638 14.9774 16.1458 13.6809 16.8234C10.6569 18.5472 6.75553 18.1325 4.19348 15.5704C1.11702 12.494 1.13672 7.48633 4.23749 4.38556C7.33826 1.28478 12.3459 1.26508 15.4224 4.34155Z"
                stroke="#595959"
                stroke-width="1.4"
              />
              <path
                d="M5.41992 10.8325C6.39548 12.3376 8.08387 13.3325 10.0033 13.3325C11.9226 13.3325 13.611 12.3376 14.5866 10.8325"
                stroke="#595959"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M12.0866 9.16585C12.0866 9.62609 11.1538 10.4159 10.0033 10.4159C8.85266 10.4159 7.91992 9.62609 7.91992 9.16585C7.91992 8.70562 8.85266 8.33252 10.0033 8.33252C11.1538 8.33252 12.0866 8.70562 12.0866 9.16585Z"
                fill="#595959"
              />
              <ellipse
                cx="5.78199"
                cy="8.11856"
                rx="1.45833"
                ry="0.833333"
                transform="rotate(-75 5.78199 8.11856)"
                fill="#595959"
              />
              <ellipse
                cx="1.45833"
                cy="0.833333"
                rx="1.45833"
                ry="0.833333"
                transform="matrix(-0.258819 -0.965926 -0.965926 0.258819 15.4004 9.31152)"
                fill="#595959"
              />
            </svg>
          </span>
          <span className="active-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M15.4224 4.34155C17.9844 6.9036 18.3992 10.805 16.6753 13.829C15.9227 15.2005 18.0157 16.2733 17.0705 17.2186C16.1253 18.1638 14.9774 16.1458 13.6809 16.8234C10.6569 18.5472 6.75553 18.1325 4.19348 15.5704C1.11702 12.494 1.13672 7.48633 4.23749 4.38556C7.33826 1.28478 12.3459 1.26508 15.4224 4.34155Z"
                stroke="#007AFF"
                stroke-width="1.4"
              />
              <path
                d="M5.41992 10.8325C6.39548 12.3376 8.08387 13.3325 10.0033 13.3325C11.9226 13.3325 13.611 12.3376 14.5866 10.8325"
                stroke="#007AFF"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M12.0866 9.16585C12.0866 9.62609 11.1538 10.4159 10.0033 10.4159C8.85266 10.4159 7.91992 9.62609 7.91992 9.16585C7.91992 8.70562 8.85266 8.33252 10.0033 8.33252C11.1538 8.33252 12.0866 8.70562 12.0866 9.16585Z"
                fill="#007AFF"
              />
              <ellipse
                cx="5.78199"
                cy="8.11856"
                rx="1.45833"
                ry="0.833333"
                transform="rotate(-75 5.78199 8.11856)"
                fill="#007AFF"
              />
              <ellipse
                cx="1.45833"
                cy="0.833333"
                rx="1.45833"
                ry="0.833333"
                transform="matrix(-0.258819 -0.965926 -0.965926 0.258819 15.4004 9.31152)"
                fill="#007AFF"
              />
            </svg>
          </span>
          <span className="icon-title">咨询</span>
        </div>
      </ComponentLog>
      {feedBack && (
        <ComponentLog>
          <div
            clstag="yx_center|top navigation_feedback"
            id="acore-feedback"
            className="feedback icon-item"
            onClick={() => {
              props.feedBack?.show({ alwaysShow: true });
            }}
          >
            <span className="normal-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M15.4224 4.34155C17.9844 6.9036 18.3992 10.805 16.6753 13.829C15.9227 15.2005 18.0157 16.2733 17.0705 17.2186C16.1253 18.1638 14.9774 16.1458 13.6809 16.8234C10.6569 18.5472 6.75553 18.1325 4.19348 15.5704C1.11702 12.494 1.13672 7.48633 4.23749 4.38556C7.33826 1.28478 12.3459 1.26508 15.4224 4.34155Z"
                  stroke="#595959"
                  stroke-width="1.4"
                />
                <path d="M6.66699 8.33325L12.917 8.33325" stroke="#595959" stroke-width="1.4" stroke-linecap="round" />
                <path d="M6.66699 11.6667H10.0003" stroke="#595959" stroke-width="1.4" stroke-linecap="round" />
              </svg>
            </span>
            <span className="active-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M15.4224 4.34155C17.9844 6.9036 18.3992 10.805 16.6753 13.829C15.9227 15.2005 18.0157 16.2733 17.0705 17.2186C16.1253 18.1638 14.9774 16.1458 13.6809 16.8234C10.6569 18.5472 6.75553 18.1325 4.19348 15.5704C1.11702 12.494 1.13672 7.48633 4.23749 4.38556C7.33826 1.28478 12.3459 1.26508 15.4224 4.34155Z"
                  stroke="#007AFF"
                  stroke-width="1.4"
                />
                <path d="M6.66699 8.33325L12.917 8.33325" stroke="#007AFF" stroke-width="1.4" stroke-linecap="round" />
                <path d="M6.66699 11.6667H10.0003" stroke="#007AFF" stroke-width="1.4" stroke-linecap="round" />
              </svg>
            </span>
            <span className="icon-title">反馈</span>
          </div>
        </ComponentLog>
      )}
    </Space>
  );
};

export default connect(
  (state) => {
    return { feedBack: state.feedback?.instance };
  },
  (dispatch) => {
    // 改变redux里面的值 刷新页面
    return {
      setNewFeedbackInstance(data) {
        dispatch(setNewFeedbackInstance(data));
      },
    };
  }
)(FeedBack);
